import { useEffect } from 'react';

export function useEffectUnmounted(callback: () => void) {
  return useEffect(
    () => callback,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
}
